import {
  GET_DEAL,
  GET_DEAL_SUCCESS,
  GET_DEAL_FAIL,
  DELETE_DEAL,
  DELETE_DEAL_SUCCESS,
  DELETE_DEAL_FAIL,
  UPDATE_DEAL,
  UPDATE_DEAL_SUCCESS,
  UPDATE_DEAL_FAIL,
  ADD_NEW_DEAL,
  ADD_DEAL_SUCCESS,
  ADD_DEAL_FAIL,
  DEAL_LOADING,
  DEAL_RESET,
} from "./actionType";

export const resetDealState = (actionType) => ({
  type: DEAL_RESET,
  payload: { actionType },
});

export const getDealSuccess = (actionType, data) => ({
  type: GET_DEAL_SUCCESS,
  payload: { actionType, data },
});

export const getDealFail = (actionType, error) => ({
  type: GET_DEAL_FAIL,
  payload: { actionType, error },
});

export const getDeal = (data) => ({
  type: GET_DEAL,
  payload: data,
});

export const getDealLoading = () => ({
  type: DEAL_LOADING,
});

export const deleteDeal = (data) => ({
  type: DELETE_DEAL,
  payload: data,
});

export const deleteDealSuccess = (data) => ({
  type: DELETE_DEAL_SUCCESS,
  payload: data,
});

export const deleteDealFail = (error) => ({
  type: DELETE_DEAL_FAIL,
  payload: error,
});

export const updateDeal = (data) => ({
  type: UPDATE_DEAL,
  payload: data,
});

export const updateDealFail = (error) => ({
  type: UPDATE_DEAL_FAIL,
  payload: error,
});

export const updateDealSuccess = (data) => ({
  type: UPDATE_DEAL_SUCCESS,
  payload: data,
});

export const addNewDeal = (data) => ({
  type: ADD_NEW_DEAL,
  payload: data,
});

export const addDealSuccess = (data) => ({
  type: ADD_DEAL_SUCCESS,
  payload: data,
});

export const addDealFail = (error) => ({
  type: ADD_DEAL_FAIL,
  payload: error,
});
